'use client';

import React from 'react';
import { ExperienceType } from '../types';
import { typography } from '@/design-system/tokens/typography';
import Border from '../../common/border';

interface ExperienceLocationProps {
  experience: unknown;
  type: ExperienceType;
}

export const ExperienceLocation: React.FC<ExperienceLocationProps> = ({
  experience,
  type,
}) => {
  if (!experience || type !== 'stay') return null;

  const getLocation = () => {
    const exp = experience as {
      location?: {
        address?: string;
        city?: string;
        state?: string;
        country?: string;
        coordinates?: { lat?: number; lng?: number };
      };
    };
    return exp?.location;
  };

  const location = getLocation();

  if (!location) return null;

  return (
    <div className='space-y-4'>
      <h2
        className='font-semibold text-gray-900'
        style={{
          fontSize: typography.size.lg, // 18px
          fontFamily: typography.fonts.primary,
          lineHeight: 'normal',
        }}
      >
        Location
      </h2>
      <div className='bg-gray-50 rounded-lg p-6'>
        <div className='space-y-2'>
          {location.address && (
            <p className='text-gray-700'>
              <span className='font-medium'>Address:</span> {location.address}
            </p>
          )}
          {(location.city || location.state || location.country) && (
            <p className='text-gray-700'>
              {[location.city, location.state, location.country]
                .filter(Boolean)
                .join(', ')}
            </p>
          )}
          {location.coordinates && (
            <div className='mt-4'>
              <div className='w-full h-64 bg-gray-200 rounded-lg flex items-center justify-center'>
                <p className='text-gray-500 text-sm'>Map View</p>
              </div>
            </div>
          )}
        </div>
      </div>
      <div className='pt-8'>
        <Border />
      </div>
    </div>
  );
};
